/* LIST OF ALL REDUCERS AVAILABLE */

/* SYSTEM */
export const LOADING = 'LOADING';
export const READY = 'READY';
export const PAGE_LOADING = 'PAGE_LOADING';
export const PAGE_READY = 'PAGE_READY';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_ABORT_CONTROLLER = 'SET_ABORT_CONTROLLER';
export const SET_OS = 'SET_OS';
export const SET_PLATFORM = 'SET_PLATFORM';
export const INCREMENT_ERROR_COUNT = 'INCREMENT_ERROR_COUNT';
export const RESET_ERROR_COUNT = 'RESET_ERROR_COUNT';
export const UPDATE_ANCHORS_REFS = 'UPDATE_ANCHORS_REFS';
export const SET_APP_FAILURE = 'SET_APP_FAILURE';
export const SET_USER_FEEDBACK_DISPLAYED = 'SET_USER_FEEDBACK_DISPLAYED';

/* TOAST */
export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';

/* MODAL */
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

/* CONFIGURATIONS */
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const UPDATE_CONFIGURATIONS = 'UPDATE_CONFIGURATIONS';
export const UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION';

/* NOTIFICATION */
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const DELETE_NOTIFICATION_BY_ID = 'DELETE_NOTIFICATION_BY_ID';
export const DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS';

/* NAVIGATION */
export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';

/* USER */
export const SET_USER = 'SET_USER';

/* DASHBOARD DATATABLE */
export const SET_DASHBOARD_DATATABLE = 'SET_DASHBOARD_DATATABLE';
